import { Link, NavLink } from "react-router-dom";
import { useAuth } from "../lib/useAuth";

export default function Layout({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b border-ink/10 bg-paper sticky top-0 z-10 backdrop-blur supports-[backdrop-filter]:bg-paper/80">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="font-semibold no-underline text-ink hover:text-cedar">
            rebuild lebanon
          </Link>
          <nav className="flex items-center gap-5 text-sm">
            <NavItem to="/themes">Themes</NavItem>
            <NavItem to="/results">Results</NavItem>
            <NavItem to="/about">About</NavItem>
            {loading ? (
              <span className="text-muted">…</span>
            ) : user ? (
              <NavItem to="/profile">
                @{user.username}
              </NavItem>
            ) : (
              <NavLink to="/register" className="btn-primary text-xs">
                Register
              </NavLink>
            )}
          </nav>
        </div>
      </header>

      <main className="flex-1">
        <div className="max-w-5xl mx-auto px-6 py-10">{children}</div>
      </main>

      <footer className="border-t border-ink/10 bg-sand/50">
        <div className="max-w-5xl mx-auto px-6 py-6 text-sm text-muted flex flex-wrap items-center justify-between gap-2">
          <div>
            v0 — consultative, not constitutionally binding. Anonymous voting.{" "}
            <a
              href="https://github.com/sboghossian/rebuild-lebanon"
              className="underline"
              rel="noreferrer"
            >
              source
            </a>
            .
          </div>
          <div>
            <Link to="/about" className="underline">
              CC BY-SA 4.0
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

function NavItem({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `no-underline ${isActive ? "text-cedar font-medium" : "text-ink hover:text-cedar"}`
      }
    >
      {children}
    </NavLink>
  );
}
